module.exports = __webpack_public_path__ + "static/img/qq_img_1.ad307e6b.png";